import React from "react";
import * as S from "./GroupShort.styled";
import LinkTo from "components/navigation/link/LinkTo";

type GroupShortProps = {
  link: string;
  name: string;
  image: string;
  text: string;
};

const GroupShort: React.FC<GroupShortProps> = ({
  link,
  name,
  image,
  text,
}: GroupShortProps) => {
  return (
    <S.ArtistRow>
      <S.ImageColumn>
        <S.Link href={link}>
          <S.Image src={image} alt={name} />
        </S.Link>
      </S.ImageColumn>

      <S.TextColumn>
        <S.Link href={link}>
          <S.ArtistName>{name}</S.ArtistName>
        </S.Link>
        <p>{text}</p>
        <S.Link href={link}>
          dalje...
          <S.ArrowIcon src="images/strelica.jpg" alt="Strelica" height={15} />
        </S.Link>
      </S.TextColumn>
    </S.ArtistRow>
  );
};

export default GroupShort;
